var styles = {"toast-container":"ToastPortal_toast-container_1s5j5_1","toast":"ToastPortal_toast_1s5j5_1","toast-progress-bottom":"ToastPortal_toast-progress-bottom_1s5j5_28","progress-bar":"ToastPortal_progress-bar_1s5j5_31"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
